import React, { Component } from 'react';
import { connect } from 'react-redux';

class ProjectItem extends Component {
  render() {
    return (
      <div className="row">
        <div className="project-item col-sm-12">
          <h4>{this.props.hit.name}</h4>
          <p>{this.props.hit.ingress}</p>
          <ul className="list-unstyled">
            <li>
              <strong>
                {this.props.translations.projectImplementationDates}
              </strong> {this.props.hit.activeTime}
            </li>
            <li>
              <strong>
                {this.props.translations.projectFunder}
              </strong> {this.props.hit.funder}
            </li>
            <li>
              <strong>
                {this.props.translations.projectResearchArea}
              </strong> {this.props.hit.researchArea}
            </li>
            <li>
              <strong>
                {this.props.translations.projectType}
              </strong> {this.props.hit.projectType}
            </li>
            <li>
              <strong>
                {this.props.translations.projectTheme}
              </strong> {this.props.hit.theme}
            </li>
            <li>
              <strong>
                {this.props.translations.projectManager}
              </strong> {this.props.hit.projectManager}
            </li>
          </ul>
          <a className="btn" href={this.props.hit.url} aria-label={this.props.translations.projectReadMore + ' ' + this.props.hit.name}>
            {this.props.translations.projectReadMore} 
          </a>
          <i className="la icon-la-arrow-right" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    translations: state.translations,
  };
};

export default connect(mapStateToProps)(ProjectItem);
